module.exports = __webpack_public_path__ + "files/blue.17696d7f33ffe327a2edc3f8bb335476.png";